<div class="header">
    <div class="header-left">
        <a class="back" routerLink=".." data-test="dialog-create-lesson-back">
            <i class="pi pi-arrow-left"></i>
        </a>
        <h2>{{ 'modules.items.dialog.createLesson.title' | translate }}</h2>
    </div>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="dialog-create-lesson-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'lessons.fieldset.basic' | translate }}</h2>
        <app-form-input
            [control]="form.controls.name"
            [label]="'lessons.form.name' | translate"
            [placeholder]="'lessons.form.name.placeholder' | translate"
            inputId="name"
            testId="dialog-create-lesson-name"
        />

        <app-form-number
            [control]="form.controls.duration"
            [label]="'lessons.form.duration' | translate"
            inputId="duration"
            [min]="0"
            testId="dialog-create-lesson-duration"
        />

        <app-form-select
            [control]="form.controls.type"
            [label]="'lessons.form.type' | translate"
            [options]="typeOptions"
            inputId="type"
            testId="dialog-create-lesson-type"
        />
    </div>
</form>

<div class="footer">
    <a pButton [outlined]="true" severity="secondary" data-test="dialog-create-lesson-cancel" routerLink="..">
        <span pButtonLabel>{{ 'modules.form.cancel' | translate }}</span>
    </a>
    <p-button
        type="submit"
        [label]="'modules.items.dialog.create.submit' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="dialog-create-lesson-submit"
        (onClick)="onSubmit()"
    />
</div>
